export const Section = ({ id, eyebrow, title, intro, alt, children, testId }) => (
  <section
    id={id}
    data-testid={testId}
    className={`border-t border-[var(--tn-line)] py-24 md:py-32 scroll-mt-16 ${alt ? "bg-[var(--tn-bg-2)]" : ""}`}
  >
    <div className="max-w-[1152px] mx-auto px-5 md:px-8">
      <div className="tn-reveal max-w-3xl">
        {eyebrow && <div className="tn-eyebrow">{eyebrow}</div>}
        <h2 className="font-display text-3xl sm:text-4xl lg:text-[42px] font-semibold leading-[1.12] tracking-tight mt-4">
          {title}
        </h2>
        {intro && <p className="text-base md:text-lg text-[var(--tn-muted)] mt-5 leading-relaxed max-w-2xl">{intro}</p>}
      </div>
      <div className="mt-14">{children}</div>
    </div>
  </section>
);
